import React from 'react';
import PropTypes from 'prop-types';
import Button from './ui/Button';
import { formatRehearsalSummary } from '../constants/rehearsal';

const ChurchList = ({
  churches,
  isLoading,
  hasLoadError = false,
  onChurchSelect,
  onStartEdit,
  onRequestDeleteChurch,
}) => {
  const churchesWithSummary = churches.filter((church) => church.operationalSummary);
  const hasOperationalPriority = churchesWithSummary.length > 1;

  return (
    <>
      <h3>Igrejas Cadastradas:</h3>
      {hasOperationalPriority && (
        <p className="church-list__priority-hint">
          A lista prioriza as igrejas que precisam de atenção.
        </p>
      )}
      {!isLoading && !hasLoadError && churches.length === 0 ? (
        <p>Nenhuma igreja cadastrada.</p>
      ) : (
        <ul className="list-reset">
          {churches.map((church) => {
            const rehearsalSummary = formatRehearsalSummary(church.rehearsal);

            return (
              <li
                key={church.id}
                onClick={() => onChurchSelect(church)}
                className={`church-list__item${
                  church.operationalSummary
                    ? ` church-list__item--${church.operationalSummary.readiness.tone}`
                    : ''
                }`}
              >
                <div className="church-list__content">
                  <div className="church-list__header">
                    <strong className="church-list__name">{church.name}</strong>
                    {church.operationalSummary && (
                      <div className="church-list__status-block">
                        <span
                          className={`church-list__status church-list__status--${church.operationalSummary.readiness.tone}`}
                        >
                          {church.operationalSummary.readiness.label}
                        </span>
                        <span className="church-list__status-detail">
                          {church.operationalSummary.readiness.detail}
                        </span>
                      </div>
                    )}
                  </div>
                  {church.operationalSummary && (
                    <div className="church-list__summary">
                      <span className="church-list__summary-item">
                        <strong>Modelo:</strong> {church.operationalSummary.cultoModelLabel}
                      </span>
                      <span className="church-list__summary-item">
                        <strong>Organistas:</strong> {church.operationalSummary.organistCount}
                      </span>
                      {rehearsalSummary && (
                        <span className="church-list__summary-item church-list__summary-item--rehearsal">
                          <strong>Ensaio local:</strong> {rehearsalSummary}
                        </span>
                      )}
                    </div>
                  )}
                  {!church.operationalSummary && rehearsalSummary && (
                    <div className="church-list__summary">
                      <span className="church-list__summary-item church-list__summary-item--rehearsal">
                        <strong>Ensaio local:</strong> {rehearsalSummary}
                      </span>
                    </div>
                  )}
                </div>
                <div className="actions-row church-list__actions">
                  <Button
                    onClick={(e) => onStartEdit(e, church)}
                    disabled={isLoading}
                    variant="warning"
                    size="sm"
                  >
                    Editar
                  </Button>
                  <Button
                    onClick={(e) => onRequestDeleteChurch(e, church.id, church.name)}
                    disabled={isLoading}
                    variant="danger"
                    size="sm"
                  >
                    Excluir
                  </Button>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

ChurchList.propTypes = {
  churches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      code: PropTypes.string,
      config: PropTypes.object,
      rehearsal: PropTypes.shape({
        weekOfMonth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        weekday: PropTypes.string,
        time: PropTypes.string,
        notes: PropTypes.string,
      }),
      operationalSummary: PropTypes.shape({
        cultoModelLabel: PropTypes.string.isRequired,
        organistCount: PropTypes.number.isRequired,
        scheduleCount: PropTypes.number.isRequired,
        readiness: PropTypes.shape({
          label: PropTypes.string.isRequired,
          tone: PropTypes.string.isRequired,
          detail: PropTypes.string.isRequired,
        }).isRequired,
      }),
    })
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasLoadError: PropTypes.bool,
  onChurchSelect: PropTypes.func.isRequired,
  onStartEdit: PropTypes.func.isRequired,
  onRequestDeleteChurch: PropTypes.func.isRequired,
};

export default ChurchList;
